(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animated-shoe-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tag = 'product-spin-v5';
  if (customElements.get(tag)) return;
  const clamp = (value,min,max) => Math.max(min,Math.min(max,value));
  class ProductSpin extends HTMLElement {
    connectedCallback() {
      this.boot = requestAnimationFrame(() => {
        if (!this.isConnected) return;
        if (this.querySelector('.ps4__stage')) this.init();
        else {
          this.observer = new MutationObserver(() => {
            if (this.querySelector('.ps4__stage')) { this.observer.disconnect(); this.init(); }
          });
          this.observer.observe(this,{childList:true,subtree:true});
        }
      });
    }
    init() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.stage = this.querySelector('.ps4__stage');
      this.cards = [...this.querySelectorAll('.ps4__product')];
      if (!this.cards.length) return;
      this.dots = [...this.querySelectorAll('[data-index]')];
      this.arrows = [...this.querySelectorAll('[data-step]')];
      this.counter = this.querySelector('.ps4__count');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.active = -1; this.current = null; this.frame = 0; this.lastTime = 0;
      this.lastWidth = 0; this.scroller = window;
      this.setAttribute('data-enhanced','');
      this.dataset.version = '5';
      this.queue = () => {
        if (!this.frame) this.frame = requestAnimationFrame(time => this.render(time));
      };
      this.resize = () => { this.measure(); this.queue(); };
      // Capture also receives scroll events from themes with a scrolling main container.
      document.addEventListener('scroll',this.queue,{capture:true,passive:true,signal:this.abort.signal});
      window.addEventListener('resize',this.resize,options);
      window.addEventListener('pageshow',this.resize,options);
      window.visualViewport?.addEventListener('resize',this.resize,options);
      this.motion.addEventListener('change',this.queue,options);
      this.addEventListener('click',event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-index')) this.go(Number(button.dataset.index));
        else if (button.hasAttribute('data-step')) this.go(this.active+Number(button.dataset.step));
      },options);
      this.addEventListener('keydown',event => {
        if (!event.target.closest('.ps4__nav')) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); this.go(this.active+(event.key === 'ArrowRight' ? 1 : -1));
        }
      },options);
      document.addEventListener('shopify:block:select',event => {
        const i = this.cards.findIndex(card => card.dataset.blockId === event.detail?.blockId);
        if (i >= 0) this.go(i,true);
      },options);
      document.addEventListener('shopify:section:reorder',this.resize,options);
      // Initial track sizing can turn a theme's main element into its scroll container.
      this.headerNodes = [...document.querySelectorAll('header-component, #header-group, #shopify-section-header, .shopify-section-group-header-group header')].filter(node => !this.contains(node));
      this.measure(); this.measure(); this.show(0,0); this.queue();
      this.sizeObserver = new ResizeObserver(entries => {
        const width = entries[0]?.contentRect.width;
        if (width && Math.abs(width-(this.hostWidth||0))>1) {
          this.hostWidth=width; this.resize();
        }
      });
      this.sizeObserver.observe(this);
      this.preloader = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.cards.forEach(card => {
            const img = card.querySelector('img');
            if (img) { img.loading='eager'; if (img.decode) img.decode().catch(() => {}); }
          });
          this.preloader.disconnect();
        }
      },{root:this.scroller===window ? null : this.scroller,rootMargin:'1000px 0px'});
      this.preloader.observe(this);
      document.fonts?.ready.then(() => { if (this.isConnected) this.resize(); });
    }
    measure() {
      let scrolling = window;
      let nearestOverflow = null;
      for (let parent=this.parentElement; parent && parent!==document.documentElement; parent=parent.parentElement) {
        const overflow = getComputedStyle(parent).overflowY;
        if (!nearestOverflow && /auto|scroll|hidden|overlay/.test(overflow)) nearestOverflow=parent;
        if (parent!==document.body && /auto|scroll|overlay/.test(overflow) && parent.scrollHeight>parent.clientHeight+2) {
          scrolling=parent; break;
        }
      }
      this.scroller=scrolling;
      // No ancestor styles are modified. Overflow wrappers use an in-place translation.
      this.dataset.pin = !nearestOverflow || nearestOverflow===scrolling ? 'sticky' : 'transform';
      const width = document.documentElement.clientWidth;
      const isMobile = width < 750;
      this.syncViewport();
      const distanceSetting = isMobile ? (Number(this.dataset.distanceMobile) || 120) : (Number(this.dataset.distance) || 80);
      const minStep = isMobile ? 400 : 280;
      this.step = Math.max(minStep, this.viewport * distanceSetting / 100);
      this.lead=0; this.tail=0.18;
      this.travel=this.cards.length>1 ? (this.cards.length-1+this.lead+this.tail)*this.step : 0;
      this.style.setProperty('--ps4-height',`${this.height}px`);
      this.style.height=`${this.height+this.travel}px`;
      // A fixed stage height prevents product title/image sizes from shifting the track.
      this.stage.style.top=this.dataset.pin==='sticky' ? `${this.offset}px` : '0px';
    }
    syncViewport() {
      const viewportTop = this.viewportTop();
      const visibleHeight = window.visualViewport?.height || innerHeight;
      const available = this.scroller===window ? visibleHeight : Math.min(this.scroller.clientHeight, Math.max(220, visibleHeight-viewportTop));
      this.viewport = available;
      const requested = parseFloat(getComputedStyle(this).getPropertyValue('--ps4-top')) || 0;
      let headerBottom = viewportTop;
      if (this.dataset.autoHeader !== 'false') {
        for (const node of this.headerNodes || []) {
          const rect = node.getBoundingClientRect();
          if (rect.height <= 0 || rect.bottom <= viewportTop || rect.top > viewportTop+4 || rect.bottom-viewportTop > available*.45) continue;
          let pinned = false;
          for (let parent=node; parent && parent!==document.body; parent=parent.parentElement) {
            if (/^(fixed|sticky)$/.test(getComputedStyle(parent).position)) { pinned=true; break; }
          }
          if (pinned) headerBottom=Math.max(headerBottom,rect.bottom);
        }
      }
      this.offset=clamp(Math.max(requested,headerBottom-viewportTop),0,Math.max(0,available-220));
      this.height=Math.max(220,available-this.offset);
      this.style.setProperty('--ps4-height',`${this.height}px`);
      this.dataset.compact=this.height<480 ? 'true' : 'false';
      this.stage.style.top=this.dataset.pin==='sticky' ? `${this.offset}px` : '0px';
      if (Number.isFinite(this.travel)) this.style.height=`${this.height+this.travel}px`;
    }
    viewportTop() {
      return this.scroller===window ? 0 : this.scroller.getBoundingClientRect().top+this.scroller.clientTop;
    }
    go(index,immediate=false) {
      if (!this.travel) return;
      index=clamp(index,0,this.cards.length-1);
      this.syncViewport();
      const raw=this.viewportTop()+this.offset-this.getBoundingClientRect().top;
      const currentScroll=this.scroller===window ? window.scrollY : this.scroller.scrollTop;
      this.scroller.scrollTo({top:currentScroll-raw+(index+this.lead)*this.step,behavior:immediate||this.motion.matches ? 'instant':'smooth'});
    }
    render(time) {
      this.frame=0;
      if (!this.isConnected || !this.cards.length) return;
      this.syncViewport();
      const raw=this.viewportTop()+this.offset-this.getBoundingClientRect().top;
      const pin=clamp(raw,0,this.travel);
      if (this.dataset.pin==='transform') this.style.setProperty('--ps4-pin',`${pin}px`);
      const target=clamp(raw/this.step-this.lead,0,this.cards.length-1);
      const within=raw>=0 && raw<=this.travel;
      const dt=clamp(time-(this.lastTime||time-16.67),1,50);
      this.lastTime=time;
      if (this.current===null || !within || this.motion.matches) this.current=target;
      else this.current+=(target-this.current)*(1-Math.exp(-dt/clamp(Number(this.dataset.smoothing)||90,40,160)));
      if (Math.abs(target-this.current)<0.0001) this.current=target;
      const index=clamp(Math.floor(this.current+0.5),0,this.cards.length-1);
      // Motion follows the same tested scroll progress; only the visual trajectory changes.
      const angle=this.motion.matches ? 0 : (index-this.current)*180;
      this.show(index,angle);
      this.stage.style.setProperty('--ps4-progress',this.travel ? clamp(raw/this.travel,0,1) : 1);
      if (within && this.current!==target) this.queue();
    }
    show(index,angle) {
      if (index!==this.active) {
        const old=this.cards[this.active];
        if (old?.contains(document.activeElement)) this.dots[index]?.focus({preventScroll:true});
        this.cards.forEach((card,i) => {
          card.hidden=i!==index; card.inert=i!==index;
          card.setAttribute('aria-hidden',String(i!==index));
        });
        this.dots.forEach((dot,i) => i===index ? dot.setAttribute('aria-current','true') : dot.removeAttribute('aria-current'));
        const card=this.cards[index];
        this.style.setProperty('--ps4-bg',card.dataset.bg);
        this.style.setProperty('--ps4-ink',card.dataset.ink);
        if (this.counter) this.counter.textContent=`${index+1} / ${this.cards.length}`;
        this.arrows.forEach(button => button.disabled=Number(button.dataset.step)<0 ? index===0 : index===this.cards.length-1);
        this.active=index;
      }
      const card=this.cards[index];
      if (this.motion.matches || this.dataset.animation==='spin') {
        card.style.setProperty('--ps4-flight-transform',`rotateY(${angle}deg)`);
        card.style.setProperty('--ps4-flight-opacity','1');
        card.style.setProperty('--ps4-copy-opacity','1');
        card.style.setProperty('--ps4-copy-y','0px');
      } else {
        // Travel along an ellipse: right/back -> centre/front -> left/back.
        // At the far side, the outgoing image fades out before the next appears.
        // Only artwork flies and fades; product copy stays still and changes with the active product.
        const phase=clamp(-angle/90,-1,1);
        const distance=Math.abs(phase);
        const theta=phase*Math.PI/2;
        const strength=clamp(Number(this.dataset.flight)||55,30,90)/100;
        const x=-Math.sin(theta)*strength*100;
        const y=(Math.cos(theta)-1)*60*strength;
        const depth=-(1-Math.cos(theta))*480*strength;
        const scale=1-(1-Math.cos(theta))*0.42;
        const roll=-Math.sin(theta)*28*strength;
        const yaw=-Math.sin(theta)*30*strength;
        const pitch=Math.sin(Math.abs(theta))*8*strength;
        const fade=clamp((distance-0.65)/0.35,0,1);
        const opacity=1-fade*fade*(3-2*fade);
        card.style.setProperty('--ps4-flight-transform',`translate3d(${x.toFixed(3)}%,${y.toFixed(3)}%,${depth.toFixed(2)}px) rotateX(${pitch.toFixed(2)}deg) rotateY(${yaw.toFixed(2)}deg) rotateZ(${roll.toFixed(2)}deg) scale(${scale.toFixed(4)})`);
        card.style.setProperty('--ps4-flight-opacity',opacity.toFixed(4));
        card.style.setProperty('--ps4-copy-opacity','1');
        card.style.setProperty('--ps4-copy-y','0px');
      }
      card.style.setProperty('--ps4-angle',`${angle}deg`);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.boot); cancelAnimationFrame(this.frame);
      this.abort?.abort(); this.observer?.disconnect(); this.sizeObserver?.disconnect(); this.preloader?.disconnect();
      this.ready=false;
    }
  }
  customElements.define(tag,ProductSpin);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brandwalk-auto-hero"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const tag='brandwalk-auto-hero';if(customElements.get(tag))return;
 class BrandWalkAutoHero extends HTMLElement{
 connectedCallback(){this.boot=requestAnimationFrame(()=>this.init());}
 init(){
  if(!this.isConnected||this.abort)return;
  this.abort=new AbortController();const opts={signal:this.abort.signal};this.slides=[...this.querySelectorAll('[data-bah-slide]')];if(!this.slides.length)return;
  this.index=0;this.busy=false;this.animations=[];this.near=false;this.hover=false;this.reduce=matchMedia('(prefers-reduced-motion: reduce)');this.playing=this.dataset.autoplay==='true'&&!this.reduce.matches&&!window.Shopify?.designMode;
  this.dots=[...this.querySelectorAll('[data-bah-index]')];this.slides.forEach((el,i)=>{el.hidden=i!==0;el.inert=i!==0;});const controls=this.querySelector('.bah__controls');if(controls)controls.hidden=false;this.update();
  this.addEventListener('click',e=>{const b=e.target.closest('button');if(!b)return;if(b.hasAttribute('data-bah-play')){this.playing=!this.playing;this.update();this.schedule();return;}if(b.hasAttribute('data-bah-index'))this.move(Number(b.dataset.bahIndex),true);if(b.hasAttribute('data-bah-next'))this.move(this.index+1,true);if(b.hasAttribute('data-bah-prev'))this.move(this.index-1,true);},opts);
  this.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){this.hover=true;this.schedule();}},opts);this.addEventListener('pointerleave',()=>{this.hover=false;this.schedule();},opts);
  this.addEventListener('focusin',e=>{if(!e.target.closest('[data-bah-play]')){this.playing=false;this.update();this.schedule();}},opts);
  this.addEventListener('pointerdown',e=>{if(e.pointerType!=='mouse'&&!e.target.closest('a,button'))this.touch={x:e.clientX,y:e.clientY};},opts);
  this.addEventListener('pointerup',e=>{if(!this.touch)return;const x=e.clientX-this.touch.x,y=e.clientY-this.touch.y;this.touch=null;if(Math.abs(x)>55&&Math.abs(x)>Math.abs(y)*1.4)this.move(this.index+(x<0?1:-1),true);},opts);this.addEventListener('pointercancel',()=>{this.touch=null;},opts);
  document.addEventListener('visibilitychange',()=>this.schedule(),opts);
  this.reduce.addEventListener('change',()=>{if(this.reduce.matches){this.playing=false;this.animations.forEach(a=>a.finish());}this.update();this.schedule();},opts);
  document.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(s=>s.dataset.blockId===e.detail?.blockId);if(i>=0)this.move(i,true);},opts);
  this.io=new IntersectionObserver(es=>{this.near=es.some(e=>e.isIntersecting);this.schedule();},{threshold:.15});this.io.observe(this);
 }
 update(){const slide=this.slides?.[this.index];if(slide){this.style.setProperty('--bah-active-bg',slide.dataset.bg||'var(--bah-bg)');this.style.setProperty('--bah-active-ink',slide.dataset.ink||'var(--bah-ink)');}this.dots?.forEach((d,i)=>i===this.index?d.setAttribute('aria-current','true'):d.removeAttribute('aria-current'));const b=this.querySelector('[data-bah-play]');if(b){b.setAttribute('aria-label',this.playing?'Pause automatic slideshow':'Play automatic slideshow');b.querySelector('span').textContent=this.playing?'Pause':'Play';}}
 schedule(){clearTimeout(this.timer);if(this.playing&&this.near&&!this.hover&&!document.hidden&&!this.busy&&this.slides.length>1)this.timer=setTimeout(()=>this.move(this.index+1,false),Math.max(3000,Number(this.dataset.interval)*1000||5000));}
 async animate(el,frames){if(this.reduce.matches||!el?.animate)return;const a=el.animate(frames,{duration:Math.max(200,Number(this.dataset.duration)||650),easing:'cubic-bezier(.22,.65,.25,1)',fill:'forwards'});this.animations.push(a);try{await a.finished;}catch(e){} }
 async move(next,manual){
  if(manual){this.playing=false;this.update();}clearTimeout(this.timer);if(this.busy)return;next=(next+this.slides.length)%this.slides.length;if(next===this.index){this.schedule();return;}this.busy=true;
  const old=this.slides[this.index],incoming=this.slides[next];const effect=this.dataset.effect;
  const out=effect==='orbit'?'translate3d(-38%,-16%,-160px) rotate(-24deg) scale(.8)':effect==='tilt'?'translateX(-30%) rotate(-12deg)':'translateY(-12px)';
  const enter=effect==='orbit'?'translate3d(38%,-16%,-160px) rotate(24deg) scale(.8)':effect==='tilt'?'translateX(30%) rotate(12deg)':'translateY(12px)';
  incoming.querySelectorAll('img').forEach(img=>img.loading='eager');
  await this.animate(old.querySelector('.bah__art'),[{transform:'none',opacity:1},{transform:out,opacity:0}]);if(!this.isConnected)return;
  if(old.contains(document.activeElement))this.querySelector('[data-bah-play]')?.focus({preventScroll:true});old.hidden=true;old.inert=true;incoming.hidden=false;incoming.inert=false;this.index=next;this.update();
  await this.animate(incoming.querySelector('.bah__art'),[{transform:enter,opacity:0},{transform:'none',opacity:1}]);if(!this.isConnected)return;
  this.animations.forEach(a=>a.cancel());this.animations=[];this.busy=false;
  if(manual){const status=this.querySelector('.bah__status');if(status)status.textContent=`Slide ${next+1} of ${this.slides.length}`;}
  this.schedule();
 }
 disconnectedCallback(){cancelAnimationFrame(this.boot);clearTimeout(this.timer);this.animations?.forEach(a=>a.cancel());this.io?.disconnect();this.abort?.abort();this.abort=null;}
 }
 customElements.define(tag,BrandWalkAutoHero);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brandwalk-editorial-hero"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const tag='brandwalk-editorial-hero';if(customElements.get(tag))return;
 class EditorialHero extends HTMLElement{
 connectedCallback(){this.boot=requestAnimationFrame(()=>this.init());}
 init(){
  if(!this.isConnected||this.abort)return;
  this.slides=[...this.querySelectorAll('[data-bwe-slide]')];if(!this.slides.length)return;
  this.abort=new AbortController();const options={signal:this.abort.signal};this.run=(this.run||0)+1;this.index=0;this.busy=false;this.pending=null;this.animations=[];this.near=false;this.hover=false;this.touch=null;
  this.reduce=matchMedia('(prefers-reduced-motion: reduce)');this.playing=this.dataset.autoplay==='true'&&!this.reduce.matches&&!window.Shopify?.designMode;
  this.setAttribute('data-ready','');this.slides.forEach((s,i)=>{s.toggleAttribute('data-active',i===0);s.removeAttribute('data-transition');s.inert=i!==0;s.setAttribute('aria-hidden',String(i!==0));});
  this.dots=[...this.querySelectorAll('[data-bwe-index]')];this.playButton=this.querySelector('[data-bwe-play]');const controls=this.querySelector('.bwe__controls');if(controls)controls.hidden=false;
  this.update();
  this.addEventListener('click',e=>{const b=e.target.closest('button');if(!b)return;if(b===this.playButton){this.playing=!this.playing;this.update();this.schedule();}else if(b.hasAttribute('data-bwe-prev'))this.move(this.index-1,true);else if(b.hasAttribute('data-bwe-next'))this.move(this.index+1,true);else if(b.hasAttribute('data-bwe-index'))this.move(Number(b.dataset.bweIndex),true);},options);
  this.addEventListener('keydown',e=>{if(!e.target.closest('.bwe__controls'))return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.move(this.index+(e.key==='ArrowRight'?1:-1),true);}},options);
  this.addEventListener('focusin',e=>{if(e.target!==this.playButton)this.pause();},options);
  this.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){this.hover=true;this.schedule();}},options);this.addEventListener('pointerleave',()=>{this.hover=false;this.schedule();},options);
  this.addEventListener('pointerdown',e=>{if(e.pointerType!=='mouse'&&e.target.closest('.bwe__scene'))this.touch={x:e.clientX,y:e.clientY,id:e.pointerId};},options);
  this.addEventListener('pointerup',e=>{const t=this.touch;this.touch=null;if(!t||t.id!==e.pointerId)return;const x=e.clientX-t.x,y=e.clientY-t.y;if(Math.abs(x)>55&&Math.abs(x)>Math.abs(y)*1.4)this.move(this.index+(x<0?1:-1),true);},options);this.addEventListener('pointercancel',()=>{this.touch=null;},options);
  document.addEventListener('visibilitychange',()=>this.schedule(),options);
  this.reduce.addEventListener('change',()=>{if(this.reduce.matches){this.pause();this.animations.forEach(a=>a.finish());}},options);
  document.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(s=>s.dataset.blockId===e.detail?.blockId);if(i>=0)this.move(i,true);},options);
  if('IntersectionObserver'in window){this.io=new IntersectionObserver(es=>{this.near=es.some(e=>e.isIntersecting);this.schedule();},{threshold:0});this.io.observe(this);}else{this.near=true;this.schedule();}
 }
 pause(){this.playing=false;this.update();this.schedule();}
 update(){this.dots?.forEach((d,i)=>i===this.index?d.setAttribute('aria-current','true'):d.removeAttribute('aria-current'));if(this.playButton){const label=this.playing?this.dataset.labelPause:this.dataset.labelPlay;this.playButton.textContent=label;this.playButton.setAttribute('aria-label',label);}const count=this.querySelector('.bwe__count');if(count)count.textContent=`${this.index+1} / ${this.slides.length}`;}
 schedule(){clearTimeout(this.timer);if(this.playing&&this.near&&!this.hover&&!document.hidden&&!this.busy&&this.slides.length>1)this.timer=setTimeout(()=>this.move(this.index+1,false),Math.max(3000,Number(this.dataset.interval)*1000||5000));}
 animate(el,frames,duration,delay=0){if(!el||this.reduce.matches||!el.animate)return Promise.resolve();const a=el.animate(frames,{duration,delay,easing:'cubic-bezier(.22,.65,.25,1)',fill:'both'});this.animations.push(a);return a.finished.catch(()=>{});}
 async move(next,manual){
  if(manual)this.pause();clearTimeout(this.timer);next=(next+this.slides.length)%this.slides.length;
  if(this.busy){if(manual)this.pending=next;return;}if(next===this.index){this.schedule();return;}
  this.busy=true;const run=this.run;const old=this.slides[this.index],incoming=this.slides[next];const duration=Math.max(300,Number(this.dataset.duration)||900);
  incoming.querySelectorAll('img').forEach(img=>img.loading='eager');
  // Keep only the active slide interactive. A transition layer never receives keyboard focus.
  if(old.contains(document.activeElement))this.playButton?.focus({preventScroll:true});
  old.inert=true;incoming.inert=true;incoming.setAttribute('data-transition','');
  const effect=this.dataset.effect;const exit=effect==='orbit'?'translate3d(-35%,-15%,-130px) rotate(-20deg) scale(.8)':effect==='tilt'?'translateX(-30%) rotate(-12deg)':'translateY(-10px)';
  const enter=effect==='orbit'?'translate3d(35%,-15%,-130px) rotate(20deg) scale(.8)':effect==='tilt'?'translateX(30%) rotate(12deg)':'translateY(10px)';
  await Promise.all([
   this.animate(old,[{opacity:1},{opacity:0}],duration),
   this.animate(incoming,[{opacity:0},{opacity:1}],duration),
   this.animate(old.querySelector('.bwe__cutout-motion'),[{opacity:1,transform:'none'},{opacity:0,transform:exit}],duration*.6),
   this.animate(incoming.querySelector('.bwe__cutout-motion'),[{opacity:0,transform:enter},{opacity:1,transform:'none'}],duration*.7,duration*.3),
   this.animate(incoming.querySelector('.bwe__copy'),[{opacity:0,transform:'translateY(14px)'},{opacity:1,transform:'none'}],duration*.65,duration*.35)
  ]);
  if(!this.isConnected||run!==this.run)return;
  old.removeAttribute('data-active');old.setAttribute('aria-hidden','true');incoming.removeAttribute('data-transition');incoming.setAttribute('data-active','');incoming.setAttribute('aria-hidden','false');incoming.inert=false;
  this.animations.forEach(a=>a.cancel());this.animations=[];this.index=next;this.busy=false;this.update();
  if(manual){const status=this.querySelector('.bwe__status');if(status)status.textContent=`${next+1} / ${this.slides.length}: ${incoming.querySelector('.bwe__heading')?.textContent||''}`;}
  const pending=this.pending;this.pending=null;if(pending!==null&&pending!==this.index)this.move(pending,true);else this.schedule();
 }
 disconnectedCallback(){this.run=(this.run||0)+1;cancelAnimationFrame(this.boot);clearTimeout(this.timer);this.animations?.forEach(a=>a.cancel());this.io?.disconnect();this.abort?.abort();this.abort=null;}
 }
 customElements.define(tag,EditorialHero);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brandwalk-hero"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const tag='brandwalk-hero'; if(customElements.get(tag))return;
 class BrandWalkHero extends HTMLElement{
  connectedCallback(){this.boot=requestAnimationFrame(()=>this.init());}
  init(){
   if(!this.isConnected||this.abort)return;
   this.abort=new AbortController();this.frame=0;this.near=true;this.current=null;
   this.reduce=matchMedia('(prefers-reduced-motion: reduce)');
   this.queue=()=>{if(!this.frame)this.frame=requestAnimationFrame(t=>this.draw(t));};
   document.addEventListener('scroll',this.queue,{capture:true,passive:true,signal:this.abort.signal});
   window.addEventListener('resize',this.queue,{signal:this.abort.signal});
   this.reduce.addEventListener('change',this.queue,{signal:this.abort.signal});
   this.io=new IntersectionObserver(entries=>{this.near=entries.some(e=>e.isIntersecting);if(this.near)this.queue();},{rootMargin:'150px'});this.io.observe(this);this.queue();
  }
  draw(time){
   this.frame=0;if(!this.isConnected)return;
   const off=this.reduce.matches||this.dataset.motion==='false';
   if(!this.near&&!off)return;
   const rect=this.getBoundingClientRect();
   const target=off?0:Math.max(0,Math.min(1,-rect.top/Math.max(1,rect.height)));
   const dt=Math.min(50,Math.max(1,time-(this.time||time-16)));this.time=time;
   if(this.current===null||off)this.current=target;else this.current+=(target-this.current)*(1-Math.exp(-dt/90));
   if(Math.abs(target-this.current)<.0005)this.current=target;
   const p=this.current*Math.max(0,Math.min(100,Number(this.dataset.strength)||0))/100;
   this.style.setProperty('--bwh-x',`${p*65}px`);this.style.setProperty('--bwh-y',`${-p*65}px`);this.style.setProperty('--bwh-r',`${-15+p*20}deg`);this.style.setProperty('--bwh-photo-y',`${-p*20}px`);
   if(this.current!==target)this.queue();
  }
  disconnectedCallback(){cancelAnimationFrame(this.boot);cancelAnimationFrame(this.frame);this.abort?.abort();this.io?.disconnect();this.abort=null;}
 }
 customElements.define(tag,BrandWalkHero);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brandwalk-sale-bar"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const tag='brandwalk-sale-bar';if(customElements.get(tag))return;
 class BrandWalkSaleBar extends HTMLElement{
  connectedCallback(){this.boot=requestAnimationFrame(()=>this.init());}
  init(){
   if(!this.isConnected||this.abort||this.dataset.dismissible!=='true')return;
   const button=this.querySelector('.bwa__close');if(!button)return;
   this.abort=new AbortController();
   // Keep dismissals scoped to this exact offer and this browser tab's session.
   const content=this.querySelector('.bwa__content');
   const signature=(content?.textContent||'').trim()+'|'+(this.querySelector('a')?.getAttribute('href')||'');
   this.storageKey='brandwalk-sale-bar:'+this.dataset.key;
   const editor=Boolean(window.Shopify?.designMode);
   try{if(!editor&&sessionStorage.getItem(this.storageKey)===signature){this.hidden=true;return;}}catch(error){}
   button.hidden=false;
   button.addEventListener('click',()=>{
    // Move keyboard focus forward before removing the focused close button.
    if(document.activeElement===button){
     const next=[...document.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex="0"]')].find(el=>!this.contains(el)&&(this.compareDocumentPosition(el)&Node.DOCUMENT_POSITION_FOLLOWING)&&el.getClientRects().length&&!el.closest('[hidden],[inert]'));
     next?.focus({preventScroll:true});
    }
    this.hidden=true;
    if(!editor){try{sessionStorage.setItem(this.storageKey,signature);}catch(error){}}
   },{signal:this.abort.signal});
  }
  disconnectedCallback(){cancelAnimationFrame(this.boot);this.abort?.abort();this.abort=null;}
 }
 customElements.define(tag,BrandWalkSaleBar);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brandwalk-sale-hero"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const tag='brandwalk-sale-hero'; if(customElements.get(tag))return;
 class BrandWalkSaleHero extends HTMLElement{
  connectedCallback(){this.boot=requestAnimationFrame(()=>this.init());}
  init(){
   if(!this.isConnected||this.abort)return;
   this.abort=new AbortController();this.frame=0;this.near=true;this.current=null;
   this.reduce=matchMedia('(prefers-reduced-motion: reduce)');
   this.queue=()=>{if(!this.frame)this.frame=requestAnimationFrame(t=>this.draw(t));};
   document.addEventListener('scroll',this.queue,{capture:true,passive:true,signal:this.abort.signal});
   window.addEventListener('resize',this.queue,{signal:this.abort.signal});
   this.reduce.addEventListener('change',this.queue,{signal:this.abort.signal});
   this.io=new IntersectionObserver(entries=>{this.near=entries.some(e=>e.isIntersecting);if(this.near)this.queue();},{rootMargin:'150px'});this.io.observe(this);this.queue();this.startCountdown();
  }
  startCountdown(){
   const clock=this.querySelector('[data-sale-clock]');
   const value=(this.dataset.saleEnd||'').trim();
   // Require a timezone so customers worldwide see the same deadline.
   if(!clock||this.dataset.countdown!=='true'||!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(value))return;
   const deadline=Date.parse(value);if(!Number.isFinite(deadline))return;
   const update=()=>{
    const remaining=Math.max(0,Math.ceil((deadline-Date.now())/1000));
    if(!remaining){clock.hidden=true;clearInterval(this.timer);return;}
    clock.hidden=false;
    const parts={days:Math.floor(remaining/86400),hours:Math.floor(remaining/3600)%24,minutes:Math.floor(remaining/60)%60,seconds:remaining%60};
    Object.entries(parts).forEach(([key,value])=>{const el=clock.querySelector(`[data-sale-${key}]`);if(el)el.textContent=String(value).padStart(2,'0');});
   };
   if(deadline>Date.now()){this.timer=setInterval(update,1000);update();}
  }
  draw(time){
   this.frame=0;if(!this.isConnected)return;
   const off=this.reduce.matches||this.dataset.motion==='false';
   if(!this.near&&!off)return;
   const rect=this.getBoundingClientRect();
   const target=off?0:Math.max(0,Math.min(1,-rect.top/Math.max(1,rect.height)));
   const dt=Math.min(50,Math.max(1,time-(this.time||time-16)));this.time=time;
   if(this.current===null||off)this.current=target;else this.current+=(target-this.current)*(1-Math.exp(-dt/90));
   if(Math.abs(target-this.current)<.0005)this.current=target;
   const p=this.current*Math.max(0,Math.min(100,Number(this.dataset.strength)||0))/100;
   this.style.setProperty('--bws-x',`${p*65}px`);this.style.setProperty('--bws-y',`${-p*65}px`);this.style.setProperty('--bws-r',`${-15+p*20}deg`);this.style.setProperty('--bws-photo-y',`${-p*20}px`);
   if(this.current!==target)this.queue();
  }
  disconnectedCallback(){clearInterval(this.timer);cancelAnimationFrame(this.boot);cancelAnimationFrame(this.frame);this.abort?.abort();this.io?.disconnect();this.abort=null;}
 }
 customElements.define(tag,BrandWalkSaleHero);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orbit-collection-list"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tag='kitsyuu-orbit-section';
  if(customElements.get(tag))return;
  const clamp=(n,a,b)=>Math.max(a,Math.min(b,n));
  class OrbitSection extends HTMLElement {
    connectedCallback(){this.boot=requestAnimationFrame(()=>{if(this.isConnected)this.init();});}
    init(){
      if(this.ready)return;this.ready=true;
      this.abort=new AbortController();const options={signal:this.abort.signal};
      this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.frame=0;this.near=true;
      this.items=[...this.querySelectorAll('[data-kmo-item]')].map((box,i)=>({box,inner:box.querySelector('[data-kmo-reveal]'),value:null,complete:false,force:false,index:i})).filter(item=>item.inner);
      this.queue=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>this.render());};
      this.setAttribute('data-kmo-ready','');
      this.intersection=new IntersectionObserver(entries=>{this.near=entries.some(e=>e.isIntersecting);if(this.near)this.queue();},{rootMargin:'200px 0px'});this.intersection.observe(this);
      document.addEventListener('scroll',this.queue,{capture:true,passive:true,signal:this.abort.signal});
      window.addEventListener('resize',this.queue,options);this.motion.addEventListener('change',this.queue,options);
      this.addEventListener('focusin',e=>{this.items.forEach(item=>{if(item.box.contains(e.target))item.force=true;});this.queue();},options);
      document.addEventListener('shopify:block:select',e=>{this.items.forEach(item=>{if(item.box.dataset.blockId===e.detail?.blockId)item.force=true;});this.queue();},options);
      this.selector=this.querySelector('[data-kmo-variant]');
      if(this.selector){this.selector.addEventListener('change',()=>this.variant(),options);this.variant();}
      this.queue();
    }
    render(){
      this.frame=0;if(!this.isConnected||!this.near)return;
      const off=this.dataset.motion==='false'||this.motion.matches;
      const strength=clamp(Number(this.dataset.strength)||0,0,100)/100;
      let animate=false;
      const height=innerHeight;
      // Read untransformed wrappers, so movement never feeds back into its own geometry.
      const positions=this.items.map(item=>item.box.getBoundingClientRect().top);
      this.items.forEach((item,i)=>{
        const stagger=Number(item.box.dataset.stagger)||0;
        let target=clamp((height*.94-positions[i]-stagger*18)/Math.max(180,height*.44),0,1);
        if(off||item.force||(item.complete&&this.dataset.replay!=='true'))target=1;
        if(item.value===null||off||item.force)item.value=target;
        else item.value+=(target-item.value)*.22;
        if(Math.abs(item.value-target)<.001)item.value=target;else animate=true;
        if(item.value===1)item.complete=true;
        const t=item.value*item.value*(3-2*item.value);const remain=(1-t)*strength;
        const text=item.box.dataset.kind==='text';
        const direction=Number(item.box.dataset.direction)||(i%2?-1:1);
        const x=text?0:direction*34*remain;
        const y=(text?34:54)*remain;
        const roll=text?0:direction*6*remain;
        const yaw=text?0:-direction*10*remain;
        const scale=text?1:1-.045*remain;
        item.inner.style.setProperty('--kmo-transform',`translate3d(${x.toFixed(2)}px,${y.toFixed(2)}px,${(-55*remain).toFixed(2)}px) rotateY(${yaw.toFixed(2)}deg) rotateZ(${roll.toFixed(2)}deg) scale(${scale.toFixed(4)})`);
        item.inner.style.setProperty('--kmo-opacity',off?'1':(1-.8*remain).toFixed(4));
      });
      if(animate)this.queue();
    }
    variant(){
      const option=this.selector.selectedOptions[0];if(!option)return;
      const price=this.querySelector('[data-kmo-price]'),compare=this.querySelector('[data-kmo-compare]');
      if(price)price.textContent=option.dataset.price||'';
      if(compare){compare.textContent=option.dataset.compare||'';compare.hidden=!option.dataset.compare;}
      const button=this.querySelector('[data-kmo-submit]');
      const available=option.dataset.available==='true';const plan=option.dataset.plan==='true';
      if(button){button.disabled=!available||plan;button.textContent=!available?this.dataset.soldLabel:plan?this.dataset.planLabel:this.dataset.addLabel;}
      const quantity=this.querySelector('[name="quantity"]');
      const min=Math.max(1,Number(option.dataset.min)||1),step=Math.max(1,Number(option.dataset.step)||1),max=Number(option.dataset.max)||0;
      if(quantity){quantity.min=String(min);quantity.step=String(step);if(max)quantity.max=String(max);else quantity.removeAttribute('max');quantity.value=String(min);}
      const rule=this.querySelector('[data-kmo-rule]');
      if(rule){rule.textContent=option.dataset.rule||'';rule.hidden=!option.dataset.rule;}
      const img=this.querySelector('[data-kmo-product-image]');
      if(img&&this.dataset.customImage!=='true'&&option.dataset.image){img.removeAttribute('srcset');img.src=option.dataset.image;}
      const link=this.querySelector('[data-kmo-details]');
      if(link){const url=new URL(link.dataset.baseUrl,location.href);url.searchParams.set('variant',option.value);link.href=url.href;}
    }
    disconnectedCallback(){cancelAnimationFrame(this.boot);cancelAnimationFrame(this.frame);this.abort?.abort();this.intersection?.disconnect();this.ready=false;}
  }
  customElements.define(tag,OrbitSection);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orbit-editorial-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tag='kitsyuu-orbit-section';
  if(customElements.get(tag))return;
  const clamp=(n,a,b)=>Math.max(a,Math.min(b,n));
  class OrbitSection extends HTMLElement {
    connectedCallback(){this.boot=requestAnimationFrame(()=>{if(this.isConnected)this.init();});}
    init(){
      if(this.ready)return;this.ready=true;
      this.abort=new AbortController();const options={signal:this.abort.signal};
      this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.frame=0;this.near=true;
      this.items=[...this.querySelectorAll('[data-kmo-item]')].map((box,i)=>({box,inner:box.querySelector('[data-kmo-reveal]'),value:null,complete:false,force:false,index:i})).filter(item=>item.inner);
      this.queue=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>this.render());};
      this.setAttribute('data-kmo-ready','');
      this.intersection=new IntersectionObserver(entries=>{this.near=entries.some(e=>e.isIntersecting);if(this.near)this.queue();},{rootMargin:'200px 0px'});this.intersection.observe(this);
      document.addEventListener('scroll',this.queue,{capture:true,passive:true,signal:this.abort.signal});
      window.addEventListener('resize',this.queue,options);this.motion.addEventListener('change',this.queue,options);
      this.addEventListener('focusin',e=>{this.items.forEach(item=>{if(item.box.contains(e.target))item.force=true;});this.queue();},options);
      document.addEventListener('shopify:block:select',e=>{this.items.forEach(item=>{if(item.box.dataset.blockId===e.detail?.blockId)item.force=true;});this.queue();},options);
      this.selector=this.querySelector('[data-kmo-variant]');
      if(this.selector){this.selector.addEventListener('change',()=>this.variant(),options);this.variant();}
      this.queue();
    }
    render(){
      this.frame=0;if(!this.isConnected||!this.near)return;
      const off=this.dataset.motion==='false'||this.motion.matches;
      const strength=clamp(Number(this.dataset.strength)||0,0,100)/100;
      let animate=false;
      const height=innerHeight;
      // Read untransformed wrappers, so movement never feeds back into its own geometry.
      const positions=this.items.map(item=>item.box.getBoundingClientRect().top);
      this.items.forEach((item,i)=>{
        const stagger=Number(item.box.dataset.stagger)||0;
        let target=clamp((height*.94-positions[i]-stagger*18)/Math.max(180,height*.44),0,1);
        if(off||item.force||(item.complete&&this.dataset.replay!=='true'))target=1;
        if(item.value===null||off||item.force)item.value=target;
        else item.value+=(target-item.value)*.22;
        if(Math.abs(item.value-target)<.001)item.value=target;else animate=true;
        if(item.value===1)item.complete=true;
        const t=item.value*item.value*(3-2*item.value);const remain=(1-t)*strength;
        const text=item.box.dataset.kind==='text';
        const direction=Number(item.box.dataset.direction)||(i%2?-1:1);
        const x=text?0:direction*34*remain;
        const y=(text?34:54)*remain;
        const roll=text?0:direction*6*remain;
        const yaw=text?0:-direction*10*remain;
        const scale=text?1:1-.045*remain;
        item.inner.style.setProperty('--kmo-transform',`translate3d(${x.toFixed(2)}px,${y.toFixed(2)}px,${(-55*remain).toFixed(2)}px) rotateY(${yaw.toFixed(2)}deg) rotateZ(${roll.toFixed(2)}deg) scale(${scale.toFixed(4)})`);
        item.inner.style.setProperty('--kmo-opacity',off?'1':(1-.8*remain).toFixed(4));
      });
      if(animate)this.queue();
    }
    variant(){
      const option=this.selector.selectedOptions[0];if(!option)return;
      const price=this.querySelector('[data-kmo-price]'),compare=this.querySelector('[data-kmo-compare]');
      if(price)price.textContent=option.dataset.price||'';
      if(compare){compare.textContent=option.dataset.compare||'';compare.hidden=!option.dataset.compare;}
      const button=this.querySelector('[data-kmo-submit]');
      const available=option.dataset.available==='true';const plan=option.dataset.plan==='true';
      if(button){button.disabled=!available||plan;button.textContent=!available?this.dataset.soldLabel:plan?this.dataset.planLabel:this.dataset.addLabel;}
      const quantity=this.querySelector('[name="quantity"]');
      const min=Math.max(1,Number(option.dataset.min)||1),step=Math.max(1,Number(option.dataset.step)||1),max=Number(option.dataset.max)||0;
      if(quantity){quantity.min=String(min);quantity.step=String(step);if(max)quantity.max=String(max);else quantity.removeAttribute('max');quantity.value=String(min);}
      const rule=this.querySelector('[data-kmo-rule]');
      if(rule){rule.textContent=option.dataset.rule||'';rule.hidden=!option.dataset.rule;}
      const img=this.querySelector('[data-kmo-product-image]');
      if(img&&this.dataset.customImage!=='true'&&option.dataset.image){img.removeAttribute('srcset');img.src=option.dataset.image;}
      const link=this.querySelector('[data-kmo-details]');
      if(link){const url=new URL(link.dataset.baseUrl,location.href);url.searchParams.set('variant',option.value);link.href=url.href;}
    }
    disconnectedCallback(){cancelAnimationFrame(this.boot);cancelAnimationFrame(this.frame);this.abort?.abort();this.intersection?.disconnect();this.ready=false;}
  }
  customElements.define(tag,OrbitSection);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orbit-featured-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tag='kitsyuu-orbit-section';
  if(customElements.get(tag))return;
  const clamp=(n,a,b)=>Math.max(a,Math.min(b,n));
  class OrbitSection extends HTMLElement {
    connectedCallback(){this.boot=requestAnimationFrame(()=>{if(this.isConnected)this.init();});}
    init(){
      if(this.ready)return;this.ready=true;
      this.abort=new AbortController();const options={signal:this.abort.signal};
      this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.frame=0;this.near=true;
      this.items=[...this.querySelectorAll('[data-kmo-item]')].map((box,i)=>({box,inner:box.querySelector('[data-kmo-reveal]'),value:null,complete:false,force:false,index:i})).filter(item=>item.inner);
      this.queue=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>this.render());};
      this.setAttribute('data-kmo-ready','');
      this.intersection=new IntersectionObserver(entries=>{this.near=entries.some(e=>e.isIntersecting);if(this.near)this.queue();},{rootMargin:'200px 0px'});this.intersection.observe(this);
      document.addEventListener('scroll',this.queue,{capture:true,passive:true,signal:this.abort.signal});
      window.addEventListener('resize',this.queue,options);this.motion.addEventListener('change',this.queue,options);
      this.addEventListener('focusin',e=>{this.items.forEach(item=>{if(item.box.contains(e.target))item.force=true;});this.queue();},options);
      document.addEventListener('shopify:block:select',e=>{this.items.forEach(item=>{if(item.box.dataset.blockId===e.detail?.blockId)item.force=true;});this.queue();},options);
      this.selector=this.querySelector('[data-kmo-variant]');
      if(this.selector){this.selector.addEventListener('change',()=>this.variant(),options);this.variant();}
      this.queue();
    }
    render(){
      this.frame=0;if(!this.isConnected||!this.near)return;
      const off=this.dataset.motion==='false'||this.motion.matches;
      const strength=clamp(Number(this.dataset.strength)||0,0,100)/100;
      let animate=false;
      const height=innerHeight;
      // Read untransformed wrappers, so movement never feeds back into its own geometry.
      const positions=this.items.map(item=>item.box.getBoundingClientRect().top);
      this.items.forEach((item,i)=>{
        const stagger=Number(item.box.dataset.stagger)||0;
        let target=clamp((height*.94-positions[i]-stagger*18)/Math.max(180,height*.44),0,1);
        if(off||item.force||(item.complete&&this.dataset.replay!=='true'))target=1;
        if(item.value===null||off||item.force)item.value=target;
        else item.value+=(target-item.value)*.22;
        if(Math.abs(item.value-target)<.001)item.value=target;else animate=true;
        if(item.value===1)item.complete=true;
        const t=item.value*item.value*(3-2*item.value);const remain=(1-t)*strength;
        const text=item.box.dataset.kind==='text';
        const direction=Number(item.box.dataset.direction)||(i%2?-1:1);
        const x=text?0:direction*34*remain;
        const y=(text?34:54)*remain;
        const roll=text?0:direction*6*remain;
        const yaw=text?0:-direction*10*remain;
        const scale=text?1:1-.045*remain;
        item.inner.style.setProperty('--kmo-transform',`translate3d(${x.toFixed(2)}px,${y.toFixed(2)}px,${(-55*remain).toFixed(2)}px) rotateY(${yaw.toFixed(2)}deg) rotateZ(${roll.toFixed(2)}deg) scale(${scale.toFixed(4)})`);
        item.inner.style.setProperty('--kmo-opacity',off?'1':(1-.8*remain).toFixed(4));
      });
      if(animate)this.queue();
    }
    variant(){
      const option=this.selector.selectedOptions[0];if(!option)return;
      const price=this.querySelector('[data-kmo-price]'),compare=this.querySelector('[data-kmo-compare]');
      if(price)price.textContent=option.dataset.price||'';
      if(compare){compare.textContent=option.dataset.compare||'';compare.hidden=!option.dataset.compare;}
      const button=this.querySelector('[data-kmo-submit]');
      const available=option.dataset.available==='true';const plan=option.dataset.plan==='true';
      if(button){button.disabled=!available||plan;button.textContent=!available?this.dataset.soldLabel:plan?this.dataset.planLabel:this.dataset.addLabel;}
      const quantity=this.querySelector('[name="quantity"]');
      const min=Math.max(1,Number(option.dataset.min)||1),step=Math.max(1,Number(option.dataset.step)||1),max=Number(option.dataset.max)||0;
      if(quantity){quantity.min=String(min);quantity.step=String(step);if(max)quantity.max=String(max);else quantity.removeAttribute('max');quantity.value=String(min);}
      const rule=this.querySelector('[data-kmo-rule]');
      if(rule){rule.textContent=option.dataset.rule||'';rule.hidden=!option.dataset.rule;}
      const img=this.querySelector('[data-kmo-product-image]');
      if(img&&this.dataset.customImage!=='true'&&option.dataset.image){img.removeAttribute('srcset');img.src=option.dataset.image;}
      const link=this.querySelector('[data-kmo-details]');
      if(link){const url=new URL(link.dataset.baseUrl,location.href);url.searchParams.set('variant',option.value);link.href=url.href;}
    }
    disconnectedCallback(){cancelAnimationFrame(this.boot);cancelAnimationFrame(this.frame);this.abort?.abort();this.intersection?.disconnect();this.ready=false;}
  }
  customElements.define(tag,OrbitSection);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orbit-featured-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tag='kitsyuu-orbit-section';
  if(customElements.get(tag))return;
  const clamp=(n,a,b)=>Math.max(a,Math.min(b,n));
  class OrbitSection extends HTMLElement {
    connectedCallback(){this.boot=requestAnimationFrame(()=>{if(this.isConnected)this.init();});}
    init(){
      if(this.ready)return;this.ready=true;
      this.abort=new AbortController();const options={signal:this.abort.signal};
      this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.frame=0;this.near=true;
      this.items=[...this.querySelectorAll('[data-kmo-item]')].map((box,i)=>({box,inner:box.querySelector('[data-kmo-reveal]'),value:null,complete:false,force:false,index:i})).filter(item=>item.inner);
      this.queue=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>this.render());};
      this.setAttribute('data-kmo-ready','');
      this.intersection=new IntersectionObserver(entries=>{this.near=entries.some(e=>e.isIntersecting);if(this.near)this.queue();},{rootMargin:'200px 0px'});this.intersection.observe(this);
      document.addEventListener('scroll',this.queue,{capture:true,passive:true,signal:this.abort.signal});
      window.addEventListener('resize',this.queue,options);this.motion.addEventListener('change',this.queue,options);
      this.addEventListener('focusin',e=>{this.items.forEach(item=>{if(item.box.contains(e.target))item.force=true;});this.queue();},options);
      document.addEventListener('shopify:block:select',e=>{this.items.forEach(item=>{if(item.box.dataset.blockId===e.detail?.blockId)item.force=true;});this.queue();},options);
      this.selector=this.querySelector('[data-kmo-variant]');
      if(this.selector){this.selector.addEventListener('change',()=>this.variant(),options);this.variant();}
      this.queue();
    }
    render(){
      this.frame=0;if(!this.isConnected||!this.near)return;
      const off=this.dataset.motion==='false'||this.motion.matches;
      const strength=clamp(Number(this.dataset.strength)||0,0,100)/100;
      let animate=false;
      const height=innerHeight;
      // Read untransformed wrappers, so movement never feeds back into its own geometry.
      const positions=this.items.map(item=>item.box.getBoundingClientRect().top);
      this.items.forEach((item,i)=>{
        const stagger=Number(item.box.dataset.stagger)||0;
        let target=clamp((height*.94-positions[i]-stagger*18)/Math.max(180,height*.44),0,1);
        if(off||item.force||(item.complete&&this.dataset.replay!=='true'))target=1;
        if(item.value===null||off||item.force)item.value=target;
        else item.value+=(target-item.value)*.22;
        if(Math.abs(item.value-target)<.001)item.value=target;else animate=true;
        if(item.value===1)item.complete=true;
        const t=item.value*item.value*(3-2*item.value);const remain=(1-t)*strength;
        const text=item.box.dataset.kind==='text';
        const direction=Number(item.box.dataset.direction)||(i%2?-1:1);
        const x=text?0:direction*34*remain;
        const y=(text?34:54)*remain;
        const roll=text?0:direction*6*remain;
        const yaw=text?0:-direction*10*remain;
        const scale=text?1:1-.045*remain;
        item.inner.style.setProperty('--kmo-transform',`translate3d(${x.toFixed(2)}px,${y.toFixed(2)}px,${(-55*remain).toFixed(2)}px) rotateY(${yaw.toFixed(2)}deg) rotateZ(${roll.toFixed(2)}deg) scale(${scale.toFixed(4)})`);
        item.inner.style.setProperty('--kmo-opacity',off?'1':(1-.8*remain).toFixed(4));
      });
      if(animate)this.queue();
    }
    variant(){
      const option=this.selector.selectedOptions[0];if(!option)return;
      const price=this.querySelector('[data-kmo-price]'),compare=this.querySelector('[data-kmo-compare]');
      if(price)price.textContent=option.dataset.price||'';
      if(compare){compare.textContent=option.dataset.compare||'';compare.hidden=!option.dataset.compare;}
      const button=this.querySelector('[data-kmo-submit]');
      const available=option.dataset.available==='true';const plan=option.dataset.plan==='true';
      if(button){button.disabled=!available||plan;button.textContent=!available?this.dataset.soldLabel:plan?this.dataset.planLabel:this.dataset.addLabel;}
      const quantity=this.querySelector('[name="quantity"]');
      const min=Math.max(1,Number(option.dataset.min)||1),step=Math.max(1,Number(option.dataset.step)||1),max=Number(option.dataset.max)||0;
      if(quantity){quantity.min=String(min);quantity.step=String(step);if(max)quantity.max=String(max);else quantity.removeAttribute('max');quantity.value=String(min);}
      const rule=this.querySelector('[data-kmo-rule]');
      if(rule){rule.textContent=option.dataset.rule||'';rule.hidden=!option.dataset.rule;}
      const img=this.querySelector('[data-kmo-product-image]');
      if(img&&this.dataset.customImage!=='true'&&option.dataset.image){img.removeAttribute('srcset');img.src=option.dataset.image;}
      const link=this.querySelector('[data-kmo-details]');
      if(link){const url=new URL(link.dataset.baseUrl,location.href);url.searchParams.set('variant',option.value);link.href=url.href;}
    }
    disconnectedCallback(){cancelAnimationFrame(this.boot);cancelAnimationFrame(this.frame);this.abort?.abort();this.intersection?.disconnect();this.ready=false;}
  }
  customElements.define(tag,OrbitSection);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orbit-product-details"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tag='kitsyuu-orbit-section';
  if(customElements.get(tag))return;
  const clamp=(n,a,b)=>Math.max(a,Math.min(b,n));
  class OrbitSection extends HTMLElement {
    connectedCallback(){this.boot=requestAnimationFrame(()=>{if(this.isConnected)this.init();});}
    init(){
      if(this.ready)return;this.ready=true;
      this.abort=new AbortController();const options={signal:this.abort.signal};
      this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.frame=0;this.near=true;
      this.items=[...this.querySelectorAll('[data-kmo-item]')].map((box,i)=>({box,inner:box.querySelector('[data-kmo-reveal]'),value:null,complete:false,force:false,index:i})).filter(item=>item.inner);
      this.queue=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>this.render());};
      this.setAttribute('data-kmo-ready','');
      this.intersection=new IntersectionObserver(entries=>{this.near=entries.some(e=>e.isIntersecting);if(this.near)this.queue();},{rootMargin:'200px 0px'});this.intersection.observe(this);
      document.addEventListener('scroll',this.queue,{capture:true,passive:true,signal:this.abort.signal});
      window.addEventListener('resize',this.queue,options);this.motion.addEventListener('change',this.queue,options);
      this.addEventListener('focusin',e=>{this.items.forEach(item=>{if(item.box.contains(e.target))item.force=true;});this.queue();},options);
      document.addEventListener('shopify:block:select',e=>{this.items.forEach(item=>{if(item.box.dataset.blockId===e.detail?.blockId)item.force=true;});this.queue();},options);
      this.selector=this.querySelector('[data-kmo-variant]');
      if(this.selector){this.selector.addEventListener('change',()=>this.variant(),options);this.variant();}
      this.queue();
    }
    render(){
      this.frame=0;if(!this.isConnected||!this.near)return;
      const off=this.dataset.motion==='false'||this.motion.matches;
      const strength=clamp(Number(this.dataset.strength)||0,0,100)/100;
      let animate=false;
      const height=innerHeight;
      // Read untransformed wrappers, so movement never feeds back into its own geometry.
      const positions=this.items.map(item=>item.box.getBoundingClientRect().top);
      this.items.forEach((item,i)=>{
        const stagger=Number(item.box.dataset.stagger)||0;
        let target=clamp((height*.94-positions[i]-stagger*18)/Math.max(180,height*.44),0,1);
        if(off||item.force||(item.complete&&this.dataset.replay!=='true'))target=1;
        if(item.value===null||off||item.force)item.value=target;
        else item.value+=(target-item.value)*.22;
        if(Math.abs(item.value-target)<.001)item.value=target;else animate=true;
        if(item.value===1)item.complete=true;
        const t=item.value*item.value*(3-2*item.value);const remain=(1-t)*strength;
        const text=item.box.dataset.kind==='text';
        const direction=Number(item.box.dataset.direction)||(i%2?-1:1);
        const x=text?0:direction*34*remain;
        const y=(text?34:54)*remain;
        const roll=text?0:direction*6*remain;
        const yaw=text?0:-direction*10*remain;
        const scale=text?1:1-.045*remain;
        item.inner.style.setProperty('--kmo-transform',`translate3d(${x.toFixed(2)}px,${y.toFixed(2)}px,${(-55*remain).toFixed(2)}px) rotateY(${yaw.toFixed(2)}deg) rotateZ(${roll.toFixed(2)}deg) scale(${scale.toFixed(4)})`);
        item.inner.style.setProperty('--kmo-opacity',off?'1':(1-.8*remain).toFixed(4));
      });
      if(animate)this.queue();
    }
    variant(){
      const option=this.selector.selectedOptions[0];if(!option)return;
      const price=this.querySelector('[data-kmo-price]'),compare=this.querySelector('[data-kmo-compare]');
      if(price)price.textContent=option.dataset.price||'';
      if(compare){compare.textContent=option.dataset.compare||'';compare.hidden=!option.dataset.compare;}
      const button=this.querySelector('[data-kmo-submit]');
      const available=option.dataset.available==='true';const plan=option.dataset.plan==='true';
      if(button){button.disabled=!available||plan;button.textContent=!available?this.dataset.soldLabel:plan?this.dataset.planLabel:this.dataset.addLabel;}
      const quantity=this.querySelector('[name="quantity"]');
      const min=Math.max(1,Number(option.dataset.min)||1),step=Math.max(1,Number(option.dataset.step)||1),max=Number(option.dataset.max)||0;
      if(quantity){quantity.min=String(min);quantity.step=String(step);if(max)quantity.max=String(max);else quantity.removeAttribute('max');quantity.value=String(min);}
      const rule=this.querySelector('[data-kmo-rule]');
      if(rule){rule.textContent=option.dataset.rule||'';rule.hidden=!option.dataset.rule;}
      const img=this.querySelector('[data-kmo-product-image]');
      if(img&&this.dataset.customImage!=='true'&&option.dataset.image){img.removeAttribute('srcset');img.src=option.dataset.image;}
      const link=this.querySelector('[data-kmo-details]');
      if(link){const url=new URL(link.dataset.baseUrl,location.href);url.searchParams.set('variant',option.value);link.href=url.href;}
    }
    disconnectedCallback(){cancelAnimationFrame(this.boot);cancelAnimationFrame(this.frame);this.abort?.abort();this.intersection?.disconnect();this.ready=false;}
  }
  customElements.define(tag,OrbitSection);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orbit-questions"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tag='kitsyuu-orbit-section';
  if(customElements.get(tag))return;
  const clamp=(n,a,b)=>Math.max(a,Math.min(b,n));
  class OrbitSection extends HTMLElement {
    connectedCallback(){this.boot=requestAnimationFrame(()=>{if(this.isConnected)this.init();});}
    init(){
      if(this.ready)return;this.ready=true;
      this.abort=new AbortController();const options={signal:this.abort.signal};
      this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.frame=0;this.near=true;
      this.items=[...this.querySelectorAll('[data-kmo-item]')].map((box,i)=>({box,inner:box.querySelector('[data-kmo-reveal]'),value:null,complete:false,force:false,index:i})).filter(item=>item.inner);
      this.queue=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>this.render());};
      this.setAttribute('data-kmo-ready','');
      this.intersection=new IntersectionObserver(entries=>{this.near=entries.some(e=>e.isIntersecting);if(this.near)this.queue();},{rootMargin:'200px 0px'});this.intersection.observe(this);
      document.addEventListener('scroll',this.queue,{capture:true,passive:true,signal:this.abort.signal});
      window.addEventListener('resize',this.queue,options);this.motion.addEventListener('change',this.queue,options);
      this.addEventListener('focusin',e=>{this.items.forEach(item=>{if(item.box.contains(e.target))item.force=true;});this.queue();},options);
      document.addEventListener('shopify:block:select',e=>{this.items.forEach(item=>{if(item.box.dataset.blockId===e.detail?.blockId)item.force=true;});this.queue();},options);
      this.selector=this.querySelector('[data-kmo-variant]');
      if(this.selector){this.selector.addEventListener('change',()=>this.variant(),options);this.variant();}
      this.queue();
    }
    render(){
      this.frame=0;if(!this.isConnected||!this.near)return;
      const off=this.dataset.motion==='false'||this.motion.matches;
      const strength=clamp(Number(this.dataset.strength)||0,0,100)/100;
      let animate=false;
      const height=innerHeight;
      // Read untransformed wrappers, so movement never feeds back into its own geometry.
      const positions=this.items.map(item=>item.box.getBoundingClientRect().top);
      this.items.forEach((item,i)=>{
        const stagger=Number(item.box.dataset.stagger)||0;
        let target=clamp((height*.94-positions[i]-stagger*18)/Math.max(180,height*.44),0,1);
        if(off||item.force||(item.complete&&this.dataset.replay!=='true'))target=1;
        if(item.value===null||off||item.force)item.value=target;
        else item.value+=(target-item.value)*.22;
        if(Math.abs(item.value-target)<.001)item.value=target;else animate=true;
        if(item.value===1)item.complete=true;
        const t=item.value*item.value*(3-2*item.value);const remain=(1-t)*strength;
        const text=item.box.dataset.kind==='text';
        const direction=Number(item.box.dataset.direction)||(i%2?-1:1);
        const x=text?0:direction*34*remain;
        const y=(text?34:54)*remain;
        const roll=text?0:direction*6*remain;
        const yaw=text?0:-direction*10*remain;
        const scale=text?1:1-.045*remain;
        item.inner.style.setProperty('--kmo-transform',`translate3d(${x.toFixed(2)}px,${y.toFixed(2)}px,${(-55*remain).toFixed(2)}px) rotateY(${yaw.toFixed(2)}deg) rotateZ(${roll.toFixed(2)}deg) scale(${scale.toFixed(4)})`);
        item.inner.style.setProperty('--kmo-opacity',off?'1':(1-.8*remain).toFixed(4));
      });
      if(animate)this.queue();
    }
    variant(){
      const option=this.selector.selectedOptions[0];if(!option)return;
      const price=this.querySelector('[data-kmo-price]'),compare=this.querySelector('[data-kmo-compare]');
      if(price)price.textContent=option.dataset.price||'';
      if(compare){compare.textContent=option.dataset.compare||'';compare.hidden=!option.dataset.compare;}
      const button=this.querySelector('[data-kmo-submit]');
      const available=option.dataset.available==='true';const plan=option.dataset.plan==='true';
      if(button){button.disabled=!available||plan;button.textContent=!available?this.dataset.soldLabel:plan?this.dataset.planLabel:this.dataset.addLabel;}
      const quantity=this.querySelector('[name="quantity"]');
      const min=Math.max(1,Number(option.dataset.min)||1),step=Math.max(1,Number(option.dataset.step)||1),max=Number(option.dataset.max)||0;
      if(quantity){quantity.min=String(min);quantity.step=String(step);if(max)quantity.max=String(max);else quantity.removeAttribute('max');quantity.value=String(min);}
      const rule=this.querySelector('[data-kmo-rule]');
      if(rule){rule.textContent=option.dataset.rule||'';rule.hidden=!option.dataset.rule;}
      const img=this.querySelector('[data-kmo-product-image]');
      if(img&&this.dataset.customImage!=='true'&&option.dataset.image){img.removeAttribute('srcset');img.src=option.dataset.image;}
      const link=this.querySelector('[data-kmo-details]');
      if(link){const url=new URL(link.dataset.baseUrl,location.href);url.searchParams.set('variant',option.value);link.href=url.href;}
    }
    disconnectedCallback(){cancelAnimationFrame(this.boot);cancelAnimationFrame(this.frame);this.abort?.abort();this.intersection?.disconnect();this.ready=false;}
  }
  customElements.define(tag,OrbitSection);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orbit-rich-text"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tag='kitsyuu-orbit-section';
  if(customElements.get(tag))return;
  const clamp=(n,a,b)=>Math.max(a,Math.min(b,n));
  class OrbitSection extends HTMLElement {
    connectedCallback(){this.boot=requestAnimationFrame(()=>{if(this.isConnected)this.init();});}
    init(){
      if(this.ready)return;this.ready=true;
      this.abort=new AbortController();const options={signal:this.abort.signal};
      this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.frame=0;this.near=true;
      this.items=[...this.querySelectorAll('[data-kmo-item]')].map((box,i)=>({box,inner:box.querySelector('[data-kmo-reveal]'),value:null,complete:false,force:false,index:i})).filter(item=>item.inner);
      this.queue=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>this.render());};
      this.setAttribute('data-kmo-ready','');
      this.intersection=new IntersectionObserver(entries=>{this.near=entries.some(e=>e.isIntersecting);if(this.near)this.queue();},{rootMargin:'200px 0px'});this.intersection.observe(this);
      document.addEventListener('scroll',this.queue,{capture:true,passive:true,signal:this.abort.signal});
      window.addEventListener('resize',this.queue,options);this.motion.addEventListener('change',this.queue,options);
      this.addEventListener('focusin',e=>{this.items.forEach(item=>{if(item.box.contains(e.target))item.force=true;});this.queue();},options);
      document.addEventListener('shopify:block:select',e=>{this.items.forEach(item=>{if(item.box.dataset.blockId===e.detail?.blockId)item.force=true;});this.queue();},options);
      this.selector=this.querySelector('[data-kmo-variant]');
      if(this.selector){this.selector.addEventListener('change',()=>this.variant(),options);this.variant();}
      this.queue();
    }
    render(){
      this.frame=0;if(!this.isConnected||!this.near)return;
      const off=this.dataset.motion==='false'||this.motion.matches;
      const strength=clamp(Number(this.dataset.strength)||0,0,100)/100;
      let animate=false;
      const height=innerHeight;
      // Read untransformed wrappers, so movement never feeds back into its own geometry.
      const positions=this.items.map(item=>item.box.getBoundingClientRect().top);
      this.items.forEach((item,i)=>{
        const stagger=Number(item.box.dataset.stagger)||0;
        let target=clamp((height*.94-positions[i]-stagger*18)/Math.max(180,height*.44),0,1);
        if(off||item.force||(item.complete&&this.dataset.replay!=='true'))target=1;
        if(item.value===null||off||item.force)item.value=target;
        else item.value+=(target-item.value)*.22;
        if(Math.abs(item.value-target)<.001)item.value=target;else animate=true;
        if(item.value===1)item.complete=true;
        const t=item.value*item.value*(3-2*item.value);const remain=(1-t)*strength;
        const text=item.box.dataset.kind==='text';
        const direction=Number(item.box.dataset.direction)||(i%2?-1:1);
        const x=text?0:direction*34*remain;
        const y=(text?34:54)*remain;
        const roll=text?0:direction*6*remain;
        const yaw=text?0:-direction*10*remain;
        const scale=text?1:1-.045*remain;
        item.inner.style.setProperty('--kmo-transform',`translate3d(${x.toFixed(2)}px,${y.toFixed(2)}px,${(-55*remain).toFixed(2)}px) rotateY(${yaw.toFixed(2)}deg) rotateZ(${roll.toFixed(2)}deg) scale(${scale.toFixed(4)})`);
        item.inner.style.setProperty('--kmo-opacity',off?'1':(1-.8*remain).toFixed(4));
      });
      if(animate)this.queue();
    }
    variant(){
      const option=this.selector.selectedOptions[0];if(!option)return;
      const price=this.querySelector('[data-kmo-price]'),compare=this.querySelector('[data-kmo-compare]');
      if(price)price.textContent=option.dataset.price||'';
      if(compare){compare.textContent=option.dataset.compare||'';compare.hidden=!option.dataset.compare;}
      const button=this.querySelector('[data-kmo-submit]');
      const available=option.dataset.available==='true';const plan=option.dataset.plan==='true';
      if(button){button.disabled=!available||plan;button.textContent=!available?this.dataset.soldLabel:plan?this.dataset.planLabel:this.dataset.addLabel;}
      const quantity=this.querySelector('[name="quantity"]');
      const min=Math.max(1,Number(option.dataset.min)||1),step=Math.max(1,Number(option.dataset.step)||1),max=Number(option.dataset.max)||0;
      if(quantity){quantity.min=String(min);quantity.step=String(step);if(max)quantity.max=String(max);else quantity.removeAttribute('max');quantity.value=String(min);}
      const rule=this.querySelector('[data-kmo-rule]');
      if(rule){rule.textContent=option.dataset.rule||'';rule.hidden=!option.dataset.rule;}
      const img=this.querySelector('[data-kmo-product-image]');
      if(img&&this.dataset.customImage!=='true'&&option.dataset.image){img.removeAttribute('srcset');img.src=option.dataset.image;}
      const link=this.querySelector('[data-kmo-details]');
      if(link){const url=new URL(link.dataset.baseUrl,location.href);url.searchParams.set('variant',option.value);link.href=url.href;}
    }
    disconnectedCallback(){cancelAnimationFrame(this.boot);cancelAnimationFrame(this.frame);this.abort?.abort();this.intersection?.disconnect();this.ready=false;}
  }
  customElements.define(tag,OrbitSection);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orbit-shop-the-look"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tag='kitsyuu-orbit-section';
  if(customElements.get(tag))return;
  const clamp=(n,a,b)=>Math.max(a,Math.min(b,n));
  class OrbitSection extends HTMLElement {
    connectedCallback(){this.boot=requestAnimationFrame(()=>{if(this.isConnected)this.init();});}
    init(){
      if(this.ready)return;this.ready=true;
      this.abort=new AbortController();const options={signal:this.abort.signal};
      this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.frame=0;this.near=true;
      this.items=[...this.querySelectorAll('[data-kmo-item]')].map((box,i)=>({box,inner:box.querySelector('[data-kmo-reveal]'),value:null,complete:false,force:false,index:i})).filter(item=>item.inner);
      this.queue=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>this.render());};
      this.setAttribute('data-kmo-ready','');
      this.intersection=new IntersectionObserver(entries=>{this.near=entries.some(e=>e.isIntersecting);if(this.near)this.queue();},{rootMargin:'200px 0px'});this.intersection.observe(this);
      document.addEventListener('scroll',this.queue,{capture:true,passive:true,signal:this.abort.signal});
      window.addEventListener('resize',this.queue,options);this.motion.addEventListener('change',this.queue,options);
      this.addEventListener('focusin',e=>{this.items.forEach(item=>{if(item.box.contains(e.target))item.force=true;});this.queue();},options);
      document.addEventListener('shopify:block:select',e=>{this.items.forEach(item=>{if(item.box.dataset.blockId===e.detail?.blockId)item.force=true;});this.queue();},options);
      this.selector=this.querySelector('[data-kmo-variant]');
      if(this.selector){this.selector.addEventListener('change',()=>this.variant(),options);this.variant();}
      this.queue();
    }
    render(){
      this.frame=0;if(!this.isConnected||!this.near)return;
      const off=this.dataset.motion==='false'||this.motion.matches;
      const strength=clamp(Number(this.dataset.strength)||0,0,100)/100;
      let animate=false;
      const height=innerHeight;
      // Read untransformed wrappers, so movement never feeds back into its own geometry.
      const positions=this.items.map(item=>item.box.getBoundingClientRect().top);
      this.items.forEach((item,i)=>{
        const stagger=Number(item.box.dataset.stagger)||0;
        let target=clamp((height*.94-positions[i]-stagger*18)/Math.max(180,height*.44),0,1);
        if(off||item.force||(item.complete&&this.dataset.replay!=='true'))target=1;
        if(item.value===null||off||item.force)item.value=target;
        else item.value+=(target-item.value)*.22;
        if(Math.abs(item.value-target)<.001)item.value=target;else animate=true;
        if(item.value===1)item.complete=true;
        const t=item.value*item.value*(3-2*item.value);const remain=(1-t)*strength;
        const text=item.box.dataset.kind==='text';
        const direction=Number(item.box.dataset.direction)||(i%2?-1:1);
        const x=text?0:direction*34*remain;
        const y=(text?34:54)*remain;
        const roll=text?0:direction*6*remain;
        const yaw=text?0:-direction*10*remain;
        const scale=text?1:1-.045*remain;
        item.inner.style.setProperty('--kmo-transform',`translate3d(${x.toFixed(2)}px,${y.toFixed(2)}px,${(-55*remain).toFixed(2)}px) rotateY(${yaw.toFixed(2)}deg) rotateZ(${roll.toFixed(2)}deg) scale(${scale.toFixed(4)})`);
        item.inner.style.setProperty('--kmo-opacity',off?'1':(1-.8*remain).toFixed(4));
      });
      if(animate)this.queue();
    }
    variant(){
      const option=this.selector.selectedOptions[0];if(!option)return;
      const price=this.querySelector('[data-kmo-price]'),compare=this.querySelector('[data-kmo-compare]');
      if(price)price.textContent=option.dataset.price||'';
      if(compare){compare.textContent=option.dataset.compare||'';compare.hidden=!option.dataset.compare;}
      const button=this.querySelector('[data-kmo-submit]');
      const available=option.dataset.available==='true';const plan=option.dataset.plan==='true';
      if(button){button.disabled=!available||plan;button.textContent=!available?this.dataset.soldLabel:plan?this.dataset.planLabel:this.dataset.addLabel;}
      const quantity=this.querySelector('[name="quantity"]');
      const min=Math.max(1,Number(option.dataset.min)||1),step=Math.max(1,Number(option.dataset.step)||1),max=Number(option.dataset.max)||0;
      if(quantity){quantity.min=String(min);quantity.step=String(step);if(max)quantity.max=String(max);else quantity.removeAttribute('max');quantity.value=String(min);}
      const rule=this.querySelector('[data-kmo-rule]');
      if(rule){rule.textContent=option.dataset.rule||'';rule.hidden=!option.dataset.rule;}
      const img=this.querySelector('[data-kmo-product-image]');
      if(img&&this.dataset.customImage!=='true'&&option.dataset.image){img.removeAttribute('srcset');img.src=option.dataset.image;}
      const link=this.querySelector('[data-kmo-details]');
      if(link){const url=new URL(link.dataset.baseUrl,location.href);url.searchParams.set('variant',option.value);link.href=url.href;}
    }
    disconnectedCallback(){cancelAnimationFrame(this.boot);cancelAnimationFrame(this.frame);this.abort?.abort();this.intersection?.disconnect();this.ready=false;}
  }
  customElements.define(tag,OrbitSection);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
(() => {
  if (customElements.get('kitsyuu-product-enhancement')) return;
  class KitsyuuProductEnhancement extends HTMLElement {
    connectedCallback() { this.frame = requestAnimationFrame(() => this.init()); }
    init() {
      if (!this.isConnected || this.abort) return;
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      this.reduce = matchMedia('(prefers-reduced-motion: reduce)');
      this.animations = [];
      const section = this.closest('.shopify-section') || this.parentElement;
      // Animate text and supplemental details only. Do not transform sticky columns,
      // variant forms, media galleries, zoom dialogs, or their ancestors.
      const targets = [...section.querySelectorAll('.product-details h1, [data-orbit-reveal]')];
      const strength = Math.max(0, Math.min(100, Number(this.dataset.strength) || 0)) / 100;
      if (this.dataset.motion === 'true' && !this.reduce.matches && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this.observer.unobserve(entry.target);
            if (this.reduce.matches || !entry.target.animate) return;
            entry.target.dataset.kopAnimated = '';
            this.animations.push(entry.target.animate([
              { transform: `translate3d(${12*strength}px,${26*strength}px,0) rotate(${1.2*strength}deg)`, opacity: .8 },
              { transform: 'none', opacity: 1 }
            ], { duration: 750, easing: 'cubic-bezier(.16,1,.3,1)' }));
          });
        }, { threshold: 0, rootMargin: '0px 0px -24px 0px' });
        targets.forEach(el => this.observer.observe(el));
      }
      this.reduce.addEventListener('change', () => { if (this.reduce.matches) this.animations.forEach(a => a.cancel()); }, opts);
      this.dialog = this.querySelector('.kop-size-dialog');
      this.addEventListener('click', event => {
        const opener = event.target.closest('[data-orbit-size-open]');
        if (opener && this.dialog && typeof this.dialog.showModal === 'function' && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
          event.preventDefault(); this.opener = opener; this.dialog.showModal();
        }
        if (event.target.closest('[data-orbit-size-close]')) this.dialog?.close();
      }, opts);
      this.dialog?.addEventListener('close', () => this.opener?.focus({preventScroll:true}), opts);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame); this.observer?.disconnect(); this.abort?.abort();
      this.animations?.forEach(a => a.cancel()); this.dialog?.close(); this.abort = null;
    }
  }
  customElements.define('kitsyuu-product-enhancement', KitsyuuProductEnhancement);
})();

  } catch(e) { console.error(e); }
})();
})();
